export default "__VITE_ASSET__DXhGSKre__"